import React, { PropTypes } from 'react';
import { NitroSingleSelect, NitroIcon, NitroTextField, NitroText } from 'nitro-components';

const OpenText = (props) => {
  return(
    <NitroTextField defaultValue={props.value}  onChange={props.onChange}/>
  )
}

OpenText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default OpenText;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/FilterTypes/OpenText.js